import React from 'react'
import { FaGithub,FaLinkedin, } from 'react-icons/fa'
import { HiOutlineMail } from 'react-icons/hi'

const Footer = () => {
  return (
    <footer className='py-4 text-white bg-[#0a192f] my-sm-f md:pt-10'>
            <div className='container mx-auto text-center'>
                <p className='text-md'>Copyright © {new Date().getFullYear()} Rifadh Rijan</p>
                <p className='flex justify-center gap-2'>
                <a href="https://github.com/RifadhRFD">
                    <FaGithub size={20} />
                </a>
                <a href="mailto:rifadhrfd@gmail.com">
                    <HiOutlineMail size={20} />
                </a>
                <a href="https://www.linkedin.com/in/rifadhrijan/">
                    <FaLinkedin size={20} />
                </a>
                </p>
            </div>
        </footer>
  )
}

export default Footer
